import getApiClient from '@/plugins/api-client'
import Vue from 'vue'
import { formatDate, slugify } from '@/util/helpers'

export default {
  loadPost () {
    const api = getApiClient(this.$store)
    const postId = this.$route.params.id

    api.get(`posts/${postId}`)
      .then(result => {
        this.post = result.data

        this.categoryList.push(this.post.category)

        if (this.post.publishDate) {
          this.formattedPublishDate = formatDate(new Date(this.post.publishDate))
        }
      })
      .catch(error => {
        this.error = error.response
      })
  },

  save () {
    this.errors = {}
    const api = getApiClient(this.$store)
    const method = this.post['@id'] ? 'patch' : 'post'
    const options = {}

    let endpoint = 'posts'

    if (method === 'patch') {
      options.headers = {
        'Content-Type': 'application/merge-patch+json',
      }
      endpoint = this.post['@id']
    }

    if (!this.post.slug && this.post.title) {
      this.post.slug = slugify(this.post.title)
    }

    const payload = {
      title: this.post.title,
      titleTag: this.post.titleTag,
      content: this.post.content,
      preview: this.post.preview,
      publishDate: this.post.publishDate,
      category: this.post.category,
      tags: this.post.tags,
      featured: this.post.featured,
      imageAlt: this.post.imageAlt,
      imageTitle: this.post.imageTitle,
      description: this.post.description,
      cta: this.post.cta,
      slug: this.post.slug,
    }

    if (this.isAdmin) {
      payload.status = this.post.status
    }

    if (this.post.image && this.post.image.match(/data:image\/.*?/g)) {
      payload.image = this.post.image
      payload.imageFilename = this.post.imageFilename
    }

    if (this.post.category?.id) {
      payload.category = this.post.category['@id']
    }

    if (!payload.category) {
      delete payload.category
    }

    if (!payload.publishDate) {
      payload.publishDate = new Date()
    }

    api[method](endpoint, payload, options)
      .then(result => {
        this.user = result.data
        this.$store.commit('app/raiseSuccess', 'Publicação salva com sucesso')
        this.$router.push({
          name: 'BlogPosts',
        })
      })
      .catch(error => {
        if (error.response.status === 422) {
          this.parseErrors(error.response.data)
        }
        this.$store.commit('app/raiseError', 'Falha ao salvar publicação')
      })
  },

  parseErrors (errors) {
    const self = this

    errors.violations.forEach(violation => {
      Vue.set(self.errors, violation.propertyPath, violation.message)
    })
  },

  searchCategories (query) {
    const api = getApiClient(this.$store)

    const params = {
      name: query,
    }

    api.get('categories', { params })
      .then(result => {
        this.categoryList = result.data['hydra:member']
      })
      .catch(() => {
        return false
      })
  },

  removeTag (tagToRemove) {
    this.post.tags = this.post.tags.filter(tag => {
      return tag !== tagToRemove
    })
  },
  codeEditorInit: function () {
    require('brace/mode/javascript')
    require('brace/mode/json')
    require('brace/mode/json')
    require('brace/theme/monokai')
  },
}
